var _a;
/**
 * @internal
 */
import { css } from '@emotion/react';
import { isBrowser } from '@polestar/component-warehouse-react/helpers/supports';
import LayoutIndexes from '@polestar/component-warehouse-react/tokens/layout-indexes/LayoutIndexes';
export const reduceMotion = isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-reduced-motion: reduce)').matches);
if (reduceMotion) {
    console.log('WARNING: You are using reduced motion. Animation is skipped due to this OS setting.');
}
export const reduceAnimation = (reduced = 'none') => css `
  @media (prefers-reduced-motion: reduce) {
    animation: ${reduced};
  }
`;
const createFocusStyle = (focusedStyle) => css `
  &::-moz-focus-inner {
    border: none;
  }

  &:focus {
    outline: 0;
  }

  [data-interaction-mode='keyboard'] &:focus {
    z-index: ${LayoutIndexes.popover};
    ${focusedStyle};
  }
`;
const createFocusWithinStyle = (focusedStyle) => css `
  [data-interaction-mode='keyboard'] &:focus-within {
    z-index: ${LayoutIndexes.popover};
    ${focusedStyle};
  }
`;
export const boxShadowFocus = ({ theme }) => css `
  box-shadow:
    0 0 0 ${theme.polestarApp.focus.inner.width} ${theme.polestarApp.focus.inner.color},
    0 0 0 ${theme.polestarApp.focus.outer.width} ${theme.polestarApp.focus.outer.color};
`;
export const borderBottomFocus = ({ theme }) => css `
  border-bottom: ${theme.polestarApp.focus.inner.width} solid ${theme.polestarApp.focus.outer.color};
`;
export const focusStyle = ({ theme }) => createFocusStyle(boxShadowFocus({ theme }));
export const focusWithinStyle = ({ theme }) => createFocusWithinStyle(boxShadowFocus({ theme }));
export const keyboardOnlyStyle = `[data-interaction-mode='keyboard'] &`;
export const keyboardOnlyDisableStyle = `[data-interaction-mode='keyboard'] & {
  * {
    transition: none !important;
  }
}`;
export const pointerOnlyStyle = `[data-interaction-mode='pointer'] &`;
